import { assertIsTruthy } from "./assertIsTruthy";

/**
 * When given an array of TEntity, it will execute onPage() on every page of data.
 */
export async function batchExecute<TEntity, TResult>(
  entities: TEntity[],
  onPage: (inputs: TEntity[]) => Promise<TResult>,
  pageSize: number
) {
  assertIsTruthy(
    pageSize > 0,
    "Invalid batchExecute.  PageSize must be greater than zero."
  );

  const results: TResult[] = [];
  let batch: TEntity[] = [];
  let index = 0;
  for (const e of entities) {
    batch.push(e);
    index++;
    if (index === pageSize) {
      results.push(await onPage(batch));
      index = 0;
      batch = [];
    }
  }
  if (batch.length) {
    results.push(await onPage(batch));
  }
  return results.flat();
}
